//toolbar options
export const CLOSE_IO_ACTION_NAME = "closeIo";
export const CLOSE_IO_ACTION_LABEL = "Close Inspection";
export const CLOSE_IO_ACTION_ICON = "done_all";
export const FINISH_IO_ACTION_NAME = "finishIo";
export const FINISH_IO_ACTION_LABEL = "Finish Inspection";
export const FINISH_IO_ACTION_ICON = "done";
export const LOGOUT_ACTION_NAME = "logout";
export const LOGOUT_ACTION_LABEL = "Logout";
export const LOGOUT_ACTION_ICON = "power_settings_new";
export const GENERATE_REPORT_NAME = "generateReport";
export const GENERATE_REPORT_ICON = "description";
export const GENERATE_REPORT_LABEL = "Generate Report";
export const GENERATE_REPORT_TOOLTIP = "Generate Report";

export const REOPEN_NAME = "reopen";
export const REOPEN_ICON = "replay";
export const REOPEN_LABEL = "Reopen Inspection";
export const REOPEN_TOOLTIP = "Reopen Inspection";

export const SEND_BY_EMAIL_NAME = "email";
export const SEND_BY_EMAIL_ICON = "mail_outline";
export const SEND_BY_EMAIL_LABEL = "Send Multiple Documents by Email";
export const SEND_BY_EMAIL_TOOLTIP = "Send Multiple Documents by Email";

export const REVIEW_COMMENTS_NAME = "review";
export const REVIEW_COMMENTS_ICON = "rate_review";
export const REVIEW_COMMENTS_LABEL = "Add review comments";
export const REVIEW_COMMENTS_TOOLTIP = "Add review comments";

export const RE_ASSIGN_INSPECTION_NAME = "reassign";
export const RE_ASSIGN_INSPECTION_ICON = "transfer_within_a_station";
export const RE_ASSIGN_INSPECTION_LABEL = "Re-Assign Inspection";
export const RE_ASSIGN_INSPECTION_TOOLTIP = "Re-Assign Inspection";

export const REPORT_ISSUE_ACTION_NAME = "report_issue";
export const REPORT_ISSUE_ACTION_LABEL = "Report issue";
export const REPORT_ISSUE_ACTION_ICON = "bug_report";

export const ADD_SERVICE_PROVIDER_COORDINATOR_NAME =
  "add_service_provider_coordinator";
export const ADD_SERVICE_PROVIDER_COORDINATOR_LABEL =
  "Add Service Provider Coordinators";
export const ADD_SERVICE_PROVIDER_COORDINATOR_ICON = "group_add_alt";

export const REMOVE_SERVICE_PROVIDER_COORDINATOR_NAME =
  "remove_service_provider_coordinator";
export const REMOVE_SERVICE_PROVIDER_COORDINATOR_LABEL =
  "Remove a Service Provider Coordinator";
export const REMOVE_SERVICE_PROVIDER_COORDINATOR_ICON = "person_remove_alt_1";

export const SEARCH_ACTION_NAME = "search";
export const SEARCH_ACTION_LABEL = "Search";
export const SEARCH_ACTION_ICON = "search";

export const MULTIOFFICE_ACTION_NAME = "multioffice";
export const MULTIOFFICE_ACTION_LABEL = "Multioffice";
export const MULTIOFFICE_ACTION_ICON = "account_circle";

export const INSPECTIONS_ACTION_NAME = "inspections";
export const INSPECTIONS_ACTION_LABEL = "Inspections";
export const INSPECTIONS_ACTION_ICON = "fact_check";

export const TIMESHEET_ACTIVITIES_ACTION_NAME = "timesheet-activities";
export const TIMESHEET_ACTIVITIES_ACTION_LABEL = "Timesheet Activities";
export const TIMESHEET_ACTIVITIES_ACTION_ICON = "access_time";

export const SETTINGS_ACTION_NAME = "settings";
export const SETTINGS_ACTION_LABEL = "Settings";
export const SETTINGS_ACTION_ICON = "settings";

export const DASHBOARDS_ACTION_NAME = "dashboards";
export const DASHBOARDS_ACTION_LABEL = "Dashboards";
export const DASHBOARDS_ACTION_ICON = "insert_chart_outlined";

export const BI_REPORTS_ACTION_NAME = "bi_reports";
export const BI_REPORTS_ACTION_LABEL = "BI Reports";
export const BI_REPORTS_ACTION_ICON = "bar_chart_line";

export const RESOURCES_ACTION_NAME = "resources";
export const RESOURCES_ACTION_LABEL = "Resources";
export const RESOURCES_ACTION_ICON = "supervised_user_circle";

export const ABOUT_ACTION_NAME = "about";
export const ABOUT_ACTION_LABEL = "About";
export const ABOUT_ACTION_ICON = "help_outline";

export const SHOW_DOCUMENTS_ACTION_NAME = "show_documents";
export const CLONE_INSPECTION_ACTION_NAME = "clone_inspection";

export const WARNING_ICON = "warning";

export const COTECNA_EYE = "COTECNA EYE";

//Fab Speed Dial Actions
export const FAB_ACTION_UPLOAD_DOCUMENT = "Upload Document";
export const FAB_ACTION_GENERATE_DOCUMENT = "Generate Document";
export const FAB_ACTION_GET_TAB_PICTURES = "Only pictures in this tab";
export const FAB_ACTION_GET_ALL_PICTURES = "All inspection pictures";
export const FAB_ACTION_GET_FILTERED_PICTURES = "Only Filtered Images";
export const FAB_ACTION_IMPORT_ITEM_EVENTS_FROM_INSPECTION =
  "Import item events from inspection";
export const FAB_ACTION_ADD_SINGLE_EVENT = "Add single event";

//Inspection States
export const STATUS_NEW = "New";
export const STATUS_OPEN = "Open";
export const STATUS_CLOSED = "Closed";
export const STATUS_FINISHED = "Finished";
export const STATUS_PARTIALLY_FINISHED = "Partially Finished";

//Storage keys
export const USER_KEY = "coordination-module-user";
export const SORT_ORDER_KEY = "order";
export const SORT_DIRECTION_KEY = "direction";
export const INSPECTION_ORIGINS_KEY = "inspectionOrigins";

//Control Types
export const MULTIDROPDOWN_CTRL = "MultiDropdown";

//OTHERS
export const COMDIV = "comdiv";
export const FALCON = "falcon";
export const EXTERNAL_ID = "externalId";
export const CLIENT = "client";
export const COTECNA_USER_KEY = "cotecnaUser";
export const AGRI_PRESET_REPORT = "agri - inspection";

//ROLES
export const COORDINATOR_ROLE = "Coordinator";
export const COORDINATOR_READ_ONLY_ROLE = "Coordinator Read-Only";
export const INSPECTOR_ROLE = "Inspector";
export const ADMIN_ROLE = "Admin";
export const SYSTEM_ADMIN_ROLE = "System Admin";
export const MANAGER_ROLE = "Manager";
export const GLOBAL_MANAGER_ROLE = "Global Manager";
export const CUSTOMER_ROLE = "Customer";
export const SERVICE_PROVIDER_COORDINATOR_ROLE = "Service Provider Coordinator";
export const SERVICE_PROVIDER_INSPECTOR_ROLE = "Service Provider Inspector";

//Dialog messages
export const DOWNLOAD_PICTURES_MESSAGE = "Downloading images";
export const DOWNLOAD_SINGLE_PICTURE_MESSAGE = "Downloading image";
export const SHARE_ALL_PICTURES_MESSAGE = "Sharing all images";
export const UNSHARE_ALL_PICTURES_MESSAGE = "Unsharing all images";
export const SHARE_SINGLE_PICTURE_MESSAGE = "Share image";
export const UNSHARE_SINGLE_PICTURE_MESSAGE = "Unsharing image";
export const DELETE_SINGLE_PICTURE_MESSAGE = "Deleting photo";
export const DOWNLOAD_ALL_PICTURES_MESSAGE = "Downloading all images";
export const DOWNLOAD_DOCUMENT = "Downloading document";
export const DOWNLOAD_TEMPLATE = "Downloading template";
export const DOWNLOAD_PRESET_TEMPLATE = "Downloading Preset template";
export const ITEM_CREATED_SAME_NAME_ERROR_TITLE = "Item name already in use";
export const ITEM_CREATED_SAME_NAME_ERROR_MESSAGE =
  "Item name already exists. Try again with a different name.";
export const INVALID_ITEM_QUANTITY_TITLE = "Invalid Item quantity.";
export const INVALID_ITEM_QUANTITY_LARGE_MESSAGE =
  "Invalid Item quantity. Try again with a different quantity.";
export const DOWNLOAD_TIME_MANAGEMENT_REPORT =
  "Downloading Time Management Report";

export const SHARE_ALL_TIMELOG_MESSAGE = "Sharing all timelogs";
export const UNSHARE_ALL_TIMELOG_MESSAGE = "Stop sharing all timelogs";
export const SHARE_SINGLE_TIMELOG_MESSAGE = "Sharing timelog";
export const UNSHARE_SINGLE_TIMELOG_MESSAGE = "Stop sharing timelog";

//Snackbar messages
export const GENERAL_INFO_UPDATED_OK = "General info successfully updated";
export const GENERAL_INFO_UPDATED_KO =
  "It is not possible to update the general info. Try again later.";

//Dashboard legend
export const DASHBOARD_INSPECTIONS_TAB = "Inspections";
export const DASHBOARD_INSPECTORS_TAB = "Inspectors";

//Missing fields types
export const MISSING_FIELDS_ITEMS_TYPE = "Items";
export const MISSING_FIELDS_SOW_TYPE = "Scope of Work";

//Actions
export const DOWNLOAD_ACTION = "download";
export const VIEW_ACTION = "view";
export const EDIT_ACTION = "edit";
export const DELETE_ACTION = "delete";
export const UNDERSTOOD_ACTION = "understood";

//Add inspection button
export const ADD_INSPECTION = "Add Inspection";
export const IMPORT_INSPECTIONS = "Import Inspections";
export const CLIENT_ID = "clientId";
export const PRESET_ID = "presetId";

// Account Settings
export const CULTURE_ID = "cultureId";
export const TIME_ID = "timeId";
export const FORM_ID = "formId";

export const ALLOWED_CONTENT_TYPES_200MB: string[] = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/msaccess",
  "application/x-mspublisher",
  "application/vnd.ms-publisher",
  "application/vnd.ms-xpsdocument",
  "application/oxps",
  "application/pdf",
  "text/html",
  "image/jpeg",
  "image/png",
  "image/x-dcraw",
  "image/RAW",
];

export const ALLOWED_CONTENT_TYPES_1GB: string[] = [
  "video/mpeg",
  "video/mpeg2",
  "video/mp4",
  "video/x-msvideo",
  "video/x-ms-wmv",
  "video/quicktime",
  "video/avi",
  "application/zip",
  "application/x-zip-compressed",
  "application/x-rar-compressed",
];

export const DEFAULT_MIME_TYPE = "image/jpeg";

export enum eventPropertyNames {
  startDate = "startDate",
  endDate = "endDate",
  sameStartAndEndDate = "sameStartAndEndDate",
  time = "time",
  option = "option",
  item = "item",
  name = "name",
  printInReport = "printInreport",
}

export const keysToExclude = [35, 37, 40, 41, 64, 91, 93, 123, 124, 125];

//Accounts
export const ACCOUNT_NAME_NETHERLANDS = "NL - Schiedam";
export const ACCOUNT_NAME_BRAZIL = "BR - Sao Paulo";
export const ACCOUNT_NAME_DURBAN = "ZA - Durban";
export const ACCOUNT_NAME_DUBAI = "AE - Dubai";
export const ACCOUNT_NAME_NANTES = "FR - Nantes";
export const ACCOUNT_NAME_MUMBAI = "IN - Mumbai (Cotecna)";
export const ACCOUNT_NAME_COTONOU = "BJ - Cotonou";
export const ACCOUNT_NAME_ALEXANDRIA = "EG - Alexandria";
export const ACCOUNT_NAME_ISTANBUL = "TR - Istanbul";
export const ACCOUNT_NAME_DELHI = "IN - Delhi";
export const ACCOUNT_NAME_NAIROBI = "KE - Nairobi";
export const ACCOUNT_NAME_SINGAPORE = "SG - Singapore";

//EmbeddesReportOptions
export const INDIA_DEFAULT_REPORT = "in-default-report";
export const NETHERLAND_DAILY_REPORT = "nl-daily-report";
export const NETHERLAND_MONTHLY_REPORT = "nl-monthly-report";
export const NETHERLAND_TIMELOG_REPORT = "nl-timelog-report";
export const BRAZIL_SUGAR_REPORT = "br-sugar-report";
export const BRAZIL_SOYBEAN_MEAL_REPORT = "br-soybean-meal-report";
export const BRAZIL_MAIZE_REPORT = "br-maize-report";
export const BRAZIL_SOYBEAN_IN_GRAINS_REPORT = "br-soybean-in-grains-report";
export const VOC_INSPECTIONS_REPORT = "voc-inspections-report";
export const VOC_AGRI_REPORT = "voc-agri-report";
export const INSPECTION_ANALYTICS = "inspection-analytics-report";

//States of time management
export enum InspectionTimeManagementState {
  Pending = 1,
  Submitted = 2,
  Approved = 3,
  Returned = 4
}

export const PENDING_TIME_MANAGEMENT = "Pending";
export const SUBMITTED_TIME_MANAGEMENT = "Submitted";
export const APPROVED_TIME_MANAGEMENT = "Approved";
export const RETURNED_TIME_MANAGEMENT = "Returned";

export enum InspectionListState {
  Active = "active",
  Closed = "closed",
}